import { firebaseAction } from 'vuexfire'
import db from '@/plugins/db'
import { filter, orderBy } from 'lodash'
import firebase from 'firebase/app'

// initial state
const state = {
  all: {},
}

// getters
const getters = {
  getAll: (state) => (id) => {
    if (state.all === null) {
      return []
    }
    return Object.values(state.all)
  },
  getHourDetail: (state) => (number) => {
    number = parseInt(number)
    return filter(state.all, { hourNumber: number })[0]
  },
  getLatestHour: (state) => () => {
    let orderedHours = orderBy(state.all, ['hourNumber'], ['desc'])
    if (orderedHours.length === 0) return undefined
    return orderedHours[0].hourNumber
  },
  getHourKey: (state) => (hourNumber) => {
    let number = parseInt(hourNumber)
    let keys = Object.keys(state.all)
    let matchedKey = filter(keys, function (o) {
      return state.all[o].hourNumber === number
    })
    return matchedKey[0]
  },
}

// actions
const actions = {
  bindHours: firebaseAction(context => {
    return context.bindFirebaseRef('all', db.ref('hours'))
  }),
  addHour: ({ commit }, hourDetails) => {
    hourDetails.createdAt = firebase.database.ServerValue.TIMESTAMP
    db.ref('hours').push(hourDetails)
  },
  toggleSpeedRound: ({ commit }, { hourKey: key, speedRound: changeSpeedRound }) => {
    db.ref(`hours/${key}`).update({ speedRound: changeSpeedRound })
  },
  updateHour: ({ commit }, { key, hour }) => {
    // hour.kvscPointTotal = parseInt(hour.kvscPointTotal)
    db.ref(`hours/${key}`).update(hour)
  },
}

// mutations
const mutations = {
  updateHourDetail (state, { property, value }) {
    if (state.hour) {
      state.hour[property] = value
    }
  },
  updateHour (state, { key, hour }) {
    state.hours[key] = hour
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
